
      const hubspotId = import.meta.env.VITE_APP_HUBSPOT_ID;
      if (hubspotId) {
        const s = document.createElement('script');
        s.src = `//js.hs-scripts.com/${hubspotId}.js`;
        s.async = true;
        s.defer = true;
        s.id = 'hs-script-loader';
        document.head.appendChild(s);
      }
    